<template>
  <v-container fluid>
    <v-row justify="center" class="mt-3">
      <v-col cols="12" md="10" xl="8">
        <v-card class="elevation-12" color="white"> </v-card>
        <v-card-text>
          <v-row justify="center" class="ma-5 fMontserrat" dense>
            <v-col cols="6" md="3">
              <v-dialog ref="dialogDate" v-model="menuDate" width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fecIni"
                    :label="t('startDate')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click="menuDate = true" />
                </template>
                <v-date-picker
                  v-model="fecIniPicker"
                  :label="t('startDate')"
                  bg-color="white"
                  :min="minDate"
                  @update:model-value="menuDate = false"
                  :max="today"
                  class="fMontserrat"
                  :locale="idioma"
                  :title="t('selectDate')" />
              </v-dialog>
            </v-col>
            <v-col cols="6" md="3">
              <v-dialog ref="dialogDate" v-model="menuDateFin" width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fecFinal"
                    :label="t('finalDate')"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @click="menuDateFin = true" />
                </template>
                <v-date-picker
                  v-model="fecFinalPicker"
                  :label="t('finalDate')"
                  bg-color="white"
                  @update:model-value="menuDateFin = false"
                  :min="minFecfinal"
                  :max="today"
                  class="fMontserrat"
                  :title="t('selectDate')" />
              </v-dialog>
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="ot" :label="t('pedido')" clearable />
            </v-col>
            <v-col cols="6" md="3">
              <v-text-field v-model="refClient" :label="t('reference')" append-icon="mdi-magnify" @click:append="getPedidosOptico()" clearable />
            </v-col>
          </v-row>
          <span class="fMontserrat" style="font-size: x-small"> {{ t("only30days") }}</span>
          <v-divider class="border-opacity-100 mx-n4" />
          <h3 class="fMontserrat ma-10">{{ t("myOrders") }}</h3>
          <v-data-table :headers="headers" :items="otList" disable-sort>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.Fec_Ped="{ item }">
              {{ formatFecha(item.Fec_Ped) }}
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.boton="{ item }">
              <v-icon v-if="item.Fichero === 1" title="Solicitar descarga" @click="downloadCard(item.OT)" color="#058541" class="cursorPointer"
                >mdi-card-account-details</v-icon
              >
              <v-icon v-else title="Solicitar tarjeta" @click="downloadCard(item.OT)" color="warning" class="cursorPointer"
                >mdi-card-account-details</v-icon
              >
            </template>
          </v-data-table>
        </v-card-text>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center" v-if="imgSource != ''">
      <v-col cols="12" md="10" xl="8">
        <v-img class="mx-auto" :src="'data:image/png;base64,' + imgSource" :width="300" aspect-ratio="1/1" cover />
      </v-col>
    </v-row>

    <v-overlay :model-value="overlay" color="white" class="align-center justify-center">
      <v-progress-circular color="primary" size="64" indeterminate />
    </v-overlay>
    <MsgBoxComponent ref="msgBox" />
  </v-container>
</template>

<script setup>
import { ref, onBeforeMount, computed } from "vue";
import axios from "axios";
import store from "@/store";
import router from "@/router";
import { t } from "@/functions/translation";
import MsgBoxComponent from "../components/MsgBoxComponent.vue";

const msgBox = ref(null);
const ot = ref("");
const refClient = ref("");
const imgSource = ref("");
var today = new Date();
const fecIniPicker = ref(new Date(today));
const fecFinalPicker = ref(new Date(today));
const otList = ref([]);
var menuDate = ref(false);
var menuDateFin = ref(false);
fecIniPicker.value.setDate(fecIniPicker.value.getDate() - 7);

var minFecfinal = computed(() => {
  let date = new Date(fecIniPicker.value);
  date.setDate(date.getDate() + 1);
  return date.toISOString().substr(0, 10);
});

const minDate = ref(new Date());
minDate.value.setDate(today.getDate() - 30);
minDate.value = minDate.value.toISOString().substr(0, 10);

const fecFinal = computed(() => {
  return fecFinalPicker.value.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
});

const fecIni = computed(() => {
  return fecIniPicker.value.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
});

const headers = [
  {
    title: t('pedido'),
    value: "OT",
    align: "center",
  },
  {
    title: t('date'),
    value: "Fec_Ped",
    sortable: true,
    align: "center",
  },
  {
    title: t('reference'),
    value: "REF_CLIENT",
    align: "center",
  },
  {
    title: t('product'),
    value: "Produc",
    align: "center",
  },
  {
    title: t('download'),
    value: "boton",
    align: "center",
  },
];

var overlay = ref(false);

const formatFecha = function (fecha) {
  var a = new Date(fecha);
  return a.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

const getPedidosOptico = function () {
  var optico = store.state.optico;
  overlay.value = true;
  var dto = { Optico: optico, OT: ot.value, FecIni: fecIni.value, FecFinal: fecFinal.value, RefClient: refClient.value };
  axios
    .post(process.env.VUE_APP_INDO_WS + "/ObtenerPedidosOptico", dto)
    .then((res) => {
      otList.value = res.data;
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      overlay.value = false;
    });
};

onBeforeMount(() => {
  if (store.state.optico === "") router.push("/");
  else getPedidosOptico();
});

const downloadCard = function (ot) {
  overlay.value = true;

  axios
    .get(process.env.VUE_APP_INDO_WS + "/ObtenerEcardPdf/" + ot)
    .then((res) => {
      if (res.data === "") {
        msgBox.value
            .alert({
              title: t('tryFewMinutes'),
              icon: "mdi-check-circle-outline",
              color: "green",
              btnOKColor: "green",
            })
      } else {
        var a = document.createElement("a");
        a.download = `WC_INDO_${ot}.pdf`;
        a.href = "data:application/pdf;base64," + res.data;
        a.click();
      }
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      overlay.value = false;
    });
};
</script>

<style scoped>
.rotate-image {
  transform: rotate(90deg);
  margin-left: 100px;
}

.v-card-text {
  background: white !important;
  color: black !important;
}
.v-card {
  background: white !important;
  color: black !important;
}

.fMontserrat {
  font-family: Montserrat;
}

.v-date-picker-month__day--selected .v-btn {
  background-color: #eae6e9;
}
</style>
